export default "__VITE_ASSET__68RuYNqH__"